import { fetcher } from '@commenda/utils';

const DOCUMENT_GENERATION_BASE_URL = 'document-generation';

export async function generateDocumentForTemplate(data: {
  companyId: number;
  documentTemplateId: string;
  payload?: Record<string, unknown>;
}): Promise<{
  success: boolean;
  data?: { documentGenerationRequest: { id: string } };
}> {
  try {
    const res = await fetcher(DOCUMENT_GENERATION_BASE_URL, {
      method: 'POST',
      body: data,
    });
    if (!res.ok) return { success: false, data: undefined };
    const responseData = (await res.json()) as {
      documentGenerationRequest: {
        id: string;
      };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
